import { Injectable } from '@angular/core';
import { SimpleTableMultiSort } from './interface';

@Injectable()
export class AdSimpleTableConfig {
  /**
   * èµ·å§é¡µç ï¼é»è®¤ä¸ºï¼`1`
   */
  pi?: number;
  /**
   * æ¯é¡µæ°éï¼å½è®¾ç½®ä¸º `0` è¡¨ç¤ºä¸åé¡µï¼é»è®¤ï¼`10`
   */
  ps?: number;
  /**
   * æ¯å¦æ¾ç¤ºè¾¹æ¡
   */
  bordered?: boolean;
  /**
   * tableå¤§å°
   */
  size?: 'small' | 'middle' | 'default';
  /**
   * æ¯å¦æ¾ç¤ºåé¡µå¨
   */
  showPagination?: boolean;
  /**
   * æ¯å¦æ¾ç¤ºpaginationä¸­æ¹åé¡µæ°
   */
  showSizeChanger?: boolean;
  /**
   * paginationä¸­æ¯é¡µæ¾ç¤ºæ¡ç®æ°ä¸ææ¡å¼
   */
  pageSizeOptions?: number[] = [10, 20, 30, 40, 50];
  /**
   * æ¯å¦æ¾ç¤ºpaginationä¸­å¿«éè·³è½¬
   */
  showQuickJumper?: boolean;
  /**
   * æ¯å¦æ¾ç¤ºæ»æ°æ®éï¼é»è®¤ï¼`å± {{total}} æ¡`
   */
  showTotal?: boolean | string = `å± {{total}} æ¡`;
  /**
   * æ°æ®åæ´åæ¯å¦ä¿çå¨æ°æ®åæ´åçé¡µç 
   */
  isPageIndexReset?: boolean;
  /**
   * åé¡µæ¹å
   */
  pagePlacement?: 'left' | 'center' | 'right';
  /**
   * åæ¢åé¡µæ¶è¿åé¡¶é¨
   */
  toTopInChange?: boolean;
  /**
   * è¿åé¡¶é¨åç§»å¼
   */
  toTopOffset?: number;
  /**
   * éå½åè¯·æ±åæ° `pi`ã`ps`ï¼ä¾å¦ï¼`{ pi: 'Page' }` `pi` ä¼è¢«æ¿æ¢æ Page
   */
  reqReName?: Object;
  /**
   * è¯·æ±åæ° `pi` æ¯å¦éç¨ 0 åºç´¢å¼
   */
  zeroIndexedOnPage?: boolean;
  /**
   * éå½åè¿ååæ° `total`ã`list`ï¼ä¾å¦ï¼`{ total: 'Total' }` Total ä¼è¢«å½ä½ `total`
   */
  resReName?: { total?: string | string[]; list?: string | string[] };
  /**
   * éå½åæåºå¼ï¼`columns` çéå½åé«äºå±æ§
   */
  sortReName?: { ascend?: string; descend?: string };
  /**
   * æ¯å¦å¤æåºï¼å½ `sort` å¤ä¸ªç¸åå¼æ¶èªå¨åå¹¶ï¼å»ºè®®åç«¯æ¯ææ¶ä½¿ç¨
   */
  multiSort?: boolean | SimpleTableMultiSort = false;
  /**
   * æå®æ¨¡ææ¡ç®æ ç»ä»¶çæ¥æ¶åæ°åï¼é»è®¤ï¼`record`
   */
  modalParamsName?: string;
  /**
   * åç«¯åé¡µï¼å½ `data` ä¸º`any[]` æ `Observable<any[]>` ææ
   */
  frontPagination ? = true;
}
